import { render, staticRenderFns } from "./SliderArrow.vue?vue&type=template&id=2c9efcd8&scoped=true"
import script from "./SliderArrow.vue?vue&type=script&lang=ts"
export * from "./SliderArrow.vue?vue&type=script&lang=ts"
import style0 from "./SliderArrow.vue?vue&type=style&index=0&id=2c9efcd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9efcd8",
  null
  
)

export default component.exports